export enum TaskStepStatusEnum {
  New = 'New',
  InProgress = 'In Progress',
  Completed = 'Completed'
}
